import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Carousel';
/**
 * @class NCCarousel
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCCarousel
 * @label 轮播图
 *
 */
class NCCarousel extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title Carousel容器样式
         * @description Carousel容器样式
         */
        containerClass: PropTypes.string,
        /**
         * @title Carousel父元素样式
         * @description Carousel父元素样式
         */
        wrapperClass: PropTypes.string,
        /**
         * @title Carousel单个元素样式
         * @description Carousel单个元素样式
         */
        slideClass: PropTypes.string,
        /**
        * @title 禁用滑动
        * @description 禁用滑动
        */
        noSwiping: PropTypes.bool,
        /**
       * @title 激活态slide
       * @description 激活态slide
       */
        activeSlideKey: PropTypes.number,
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        disabled: false
    }

    render() {
        return (
            <Carousel {...this.props} />
        )
    }
}

export default NCCarousel;
